
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"21","height":"20","viewBox":"0 0 21 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.67 10.07L10.742 20 .67 9.928 10.6 0l5.518 5.518-5.267 5.37-2.06-2.011-.275-.27-.275.268-1.662 1.62-.286.28.282.28 3.939 3.926.28.28.277-.281 7.225-7.283 2.374 2.374z","fill":"url(#paint0_linear_17075_98072)"}}),_c('defs',[_c('linearGradient',{attrs:{"id":"paint0_linear_17075_98072","x1":".67","y1":"10","x2":"20.67","y2":"10","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"stop-color":"#FF2545"}}),_c('stop',{attrs:{"offset":".06","stop-color":"#F42651"}}),_c('stop',{attrs:{"offset":".38","stop-color":"#C52F88"}}),_c('stop',{attrs:{"offset":".65","stop-color":"#A234B0"}}),_c('stop',{attrs:{"offset":".87","stop-color":"#8D38C8"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#863AD2"}})])])])
          )
        }
      }
    